<div class="short-detail-card-section">
  <a [href]="searchData()?.url" target="_blank"
    (click)="$event.stopPropagation()">
    <div class="short-detail-card">
      <div class="short-detail-card-icon">
        <app-svg-icons [icons]="searchData()?.icon" />
      </div>
      <div class="short-detail-card-content">
        <h3>{{searchData()?.name}}</h3>
        <p>{{searchData()?.value}}</p>
      </div>
    </div>
  </a>
</div>
